<template>
  <div class="search-ingredients form-row">
    <b-form
      class="navbar-search form-inline mr-sm-3"
    >
    <b-form-group class="mb-0">
      <b-input-group class="input-group-alternative input-group-merge">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="fas fa-search"></i></span>
        </div>
        <b-form-input 
        placeholder="Search" 
        type="text" 
        autocomplete="off" 
        class="js-header-search" 
        value="searchQuery" 
        v-model="searchQuery" 
        @focus.native="searchModalVisible = true"> </b-form-input>
      </b-input-group>
    </b-form-group>
    <div class="navbar-search__autocomplete" v-if="filteredResults.length && searchModalVisible">
      <ul v-show="this.loading" class="loading">
            <li>...</li>
      </ul>
      <ul v-show="!this.loading">
        <li v-for="(filteredResult, index) in filteredResults" :key="index" :data-id="filteredResult.id" @click="setResult(filteredResult)">
          {{ filteredResult.name}}
        </li>
      </ul>
    </div>
    </b-form>
  </div>
</template>
<script>
import LoadingPanel from '@/components/LoadingPanel.vue';
export default {
  name: "SearchIngredients",
  components: {
    LoadingPanel
  },
  data() {
    return {
      searchQuery: this.$route.query.search,
      searchModalVisible: false,
      ingredient: null,
      savedIngredient: [],
      data: null,
      pauseSearch: false,
      loading: false
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    apiKey() {
      return this.data && this.data.api_key;
    },
    isLoading() {
      return this.$store.getters.recipesLoading
    },
    filteredResults() {
      if (this.$store.state.recipes.all[1]) {
        return Object.values(this.$store.state.recipes.all[1])
      }
      return Object.values(this.$store.state.recipes.myRecipes[1])
    }
  },
  methods: {
    setResult(result) {
      this.searchQuery = result.title;
      this.searchModalVisible = false;
      this.ingredient = result;
      this.$emit("newSubRecipe", result);
    },
    searchIngredients() {
      const { dispatch } = this.$store;
      dispatch("recipes/searchRecipes",{
        "query": this.searchQuery,
        "filter": "I"
        });
    },
    checkEnter(event) {
      if (event.keyCode === 13) {
        event.preventDefault();

        if (event.target.value.length) {
          this.searchQuery = event.target.value;
        }
      }
    }
  },
  mounted() {
    let _this = this;

    document.addEventListener('click', function(event) {
      let target = event.target;

      if (!target.classList.contains('js-header-search')) {
        _this.searchModalVisible = false;
      }
    });
  },
  watch: {
    isLoading (newLoad, oldLoad) {
        this.loading = newLoad
      if ( newLoad == 'failed') {
        this.$router.push({path: `/system-error?id=${this.$route.params.id}`});
      }
    },
    searchQuery: function (val,old) {
      this.searchQuery = val;
        if (!this.pauseSearch) {
          setTimeout(() => {
            this.searchIngredients();
            this.pauseSearch = false;
          }, 1000); // 1 sec delay
        }
        this.pauseSearch = true;
    }
  }
}
</script>
<style scoped>
.search-ingredients{
  margin-bottom: 40px;
}
</style>